<section class="page-stack">
  <div class="section-header">
    <div>
      <p class="eyebrow mb-1">Loans Module</p>
      <h2>Global Loan Config</h2>
    </div>
    <button class="btn btn-accent" type="button" (click)="save()" [disabled]="saving || loading">
      {{ saving ? 'Saving...' : 'Save config' }}
    </button>
  </div>

  @if (notice) {
    <div class="alert alert-info" role="status">{{ notice }}</div>
  }
  @if (error) {
    <div class="alert alert-danger" role="alert">{{ error }}</div>
  }

  <div class="dashboard-grid">
    <div class="metric-card cyan">
      <span>Salary Limit</span>
      <strong>{{ percent(config.max_salary_percent_basis_points) }}</strong>
      <small>Maximum loan amount from verified net salary</small>
    </div>
    <div class="metric-card pink">
      <span>Interest Rate</span>
      <strong>{{ percent(config.interest_rate_basis_points) }}</strong>
      <small>Monthly interest applied at request time</small>
    </div>
    <div class="metric-card yellow">
      <span>Active Charges</span>
      <strong>{{ charges().length }}</strong>
      <small>Flat charges included in repayment schedule</small>
    </div>
  </div>

  <div class="panel p-3">
    <form class="row g-3" (ngSubmit)="save()">
      <div class="col-md-4">
        <label class="form-label">Salary limit basis points</label>
        <input class="form-control" type="number" name="limitBps" [(ngModel)]="config.max_salary_percent_basis_points">
        <div class="text-muted-soft mt-1">{{ percent(config.max_salary_percent_basis_points) }}</div>
      </div>
      <div class="col-md-4">
        <label class="form-label">Interest rate p/m basis points</label>
        <input class="form-control" type="number" name="interestBps" [(ngModel)]="config.interest_rate_basis_points">
        <div class="text-muted-soft mt-1">{{ percent(config.interest_rate_basis_points) }} per month</div>
      </div>
      <div class="col-md-4">
        <label class="form-label">Status</label>
        <select class="form-select" name="status" [(ngModel)]="config.status">
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>
    </form>
  </div>

  <div class="panel">
    <div class="section-header p-3 pb-0">
      <div>
        <p class="eyebrow mb-1">Charges</p>
        <h2>Extra Loan Charges</h2>
      </div>
      <button class="btn btn-sm btn-outline-info" type="button" (click)="addCharge()">Add charge</button>
    </div>
    <div class="table-responsive">
      <table class="table table-dark table-hover align-middle mb-0">
        <thead>
          <tr>
            <th>Description</th>
            <th>Amount (KSh)</th>
            <th>Status</th>
            <th class="text-end">Action</th>
          </tr>
        </thead>
        <tbody>
          @for (charge of charges(); track $index) {
            <tr>
              <td><input class="form-control table-control" name="description{{$index}}" [(ngModel)]="charge.description"></td>
              <td>
                <input class="form-control table-control" type="number" name="amount{{$index}}" [(ngModel)]="charge.amount_cents">
              </td>
              <td>
                <select class="form-select table-control" name="chargeStatus{{$index}}" [(ngModel)]="charge.status">
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </td>
              <td class="text-end">
                <div class="d-inline-flex gap-2">
                  <button class="btn btn-sm btn-outline-info" type="button" (click)="save()" [disabled]="saving || loading">
                    {{ saving ? 'Saving...' : 'Save' }}
                  </button>
                  <button class="btn btn-sm btn-outline-light" type="button" (click)="removeCharge($index)">
                    {{ charge.id ? 'Disable' : 'Remove' }}
                  </button>
                </div>
              </td>
            </tr>
          } @empty {
            <tr><td colspan="4" class="text-center py-4 text-muted-soft">No extra charges configured.</td></tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</section>
